import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

// Layouts
import DoctorLayout from "../components/layouts/DoctorLayout";
import PatientLayout from "../components/layouts/PatientLayout";
import PublicRoutes from "../components/layouts/PublicLayout";

// Public Routes
import AboutUs from "../containers/public/about-us/AboutUs";
import Blogs from "../containers/public/blogs/Blogs";
import Home from "../containers/public/home/Home";
import Services from "../containers/public/services/Services";

// Doctor Routes
// Doctor Auth
import DoctorForgotPasswordCreatePasswordScreen from "../containers/auth/Doctor/forgot-password/create-password/CreatePassword";
import DoctorForgotPasswordEmailScreen from "../containers/auth/Doctor/forgot-password/email/Email";
import DoctorForgotPasswordVerificationCodeScreen from "../containers/auth/Doctor/forgot-password/verify/Verify";
import DoctorLogin from "../containers/auth/Doctor/login/Login";
import DoctorSignUp from "../containers/auth/Doctor/signup/Signup";
import DoctorVerifyOtp from "../containers/auth/Doctor/verifyotp/VerifyOtp";

// Doctor Pages

// Patient Routes
import PatientForgotPasswordCreatePasswordScreen from "../containers/auth/Patient/forgot-password/create-password/CreatePassword";
import PatientForgotPasswordEmailScreen from "../containers/auth/Patient/forgot-password/email/Email";
import PatientForgotPasswordVerificationCodeScreen from "../containers/auth/Patient/forgot-password/verify/Verify";
import PatientLogin from "../containers/auth/Patient/login/Login";
import PatientSignup from "../containers/auth/Patient/signup/Signup";
import PatientVerifyOtp from "../containers/auth/Patient/verifyotp/VerifyOtp";

// GUARDS
import { useSelector } from "react-redux";
import DownloadLabForm from "../components/appointments-details-components/downloadforms/DownloadLabForm";
import PublicVideoCall from "../containers/sharedscreens/twilio-call-panel/PublicVideoCall";
import DoctorRoutes from "./doctorRoutes";
import PatientRoutes from "./patientRoutes";

const Navigation = () => {
  const user = useSelector((state) => state.userReducer.user);

  if (user) {
    // USER LOGGED IN AS DOCTOR
    if (user.userType === "doctor") {
      return <DoctorRoutes />;
    } else if (user.userType === "patient") {
      // USER LOGGED IN AS PATIENT
      return <PatientRoutes />;
    } else {
      // FALL BACK TO HOME SCREEN IF USER-TYPE IS UNKNOWN
      return (
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      );
    }
  } else {
    // PUBLIC ROUTES (NO USER IS LOGGED-IN)
    return (
      <Routes>
        {/* ALL PUBLIC ROUTES */}
        <Route path="/" element={<PublicRoutes />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="services" element={<Services />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="video-call" element={<PublicVideoCall />} />
          <Route
            path="downloadLabForm/:appointmentId"
            element={<DownloadLabForm />}
          />
        </Route>

        {/* DOCTOR PUBLIC ROUTES */}
        <Route path="/doctor" element={<DoctorLayout />}>
          <Route index element={<Navigate to="/doctor/login" replace />} />
          <Route path="login" element={<DoctorLogin />} />
          <Route path="signup" element={<DoctorSignUp />} />
          <Route path="verify-otp" element={<DoctorVerifyOtp />} />
          <Route
            path="forgot-password/email"
            element={<DoctorForgotPasswordEmailScreen />}
          />
          <Route
            path="forgot-password/verify"
            element={<DoctorForgotPasswordVerificationCodeScreen />}
          />
          <Route
            path="forgot-password/create-password"
            element={<DoctorForgotPasswordCreatePasswordScreen />}
          />
        </Route>

        {/* PATIENT PUBLIC ROUTES */}
        <Route path="/patient" element={<PatientLayout />}>
          <Route index element={<Navigate to="/patient/login" replace />} />
          <Route path="login" element={<PatientLogin />} />
          <Route path="signup" element={<PatientSignup />} />
          <Route path="verify-otp" element={<PatientVerifyOtp />} />
          <Route
            path="forgot-password/email"
            element={<PatientForgotPasswordEmailScreen />}
          />
          <Route
            path="forgot-password/verify"
            element={<PatientForgotPasswordVerificationCodeScreen />}
          />
          <Route
            path="forgot-password/create-password"
            element={<PatientForgotPasswordCreatePasswordScreen />}
          />
        </Route>

        {/* FALL BACK TO HOME SCREEN IF ANY UNKNOW ROUTE APPEARS*/}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
};

export default Navigation;
